/**
 * CWA — Customer Web Agent for The Outdoor Manor
 * Self-contained chat widget — vanilla JS, zero dependencies
 * Embed: <script src="cwa-widget.js"></script>
 */
(function() {
  'use strict';
  const WEBHOOK_URL = 'https://n8n.srv1510583.hstgr.cloud/webhook/cwa-chat';
  const BRAND = { green: '#0D1F0F', gold: '#C9A84C', darkGold: '#A8852E', white: '#F5F0E8' };
  let isOpen = false;
  let isTyping = false;
  let visitorId = 'v-' + Math.random().toString(36).substring(2, 10) + '-' + Date.now();
  let conversationHistory = [];
  let messages = [];
  const style = document.createElement('style');
  style.textContent = `
    #cwa-bubble {
      position: fixed; bottom: 24px; right: 24px; z-index: 99999;
      width: 60px; height: 60px; border-radius: 50%;
      background: #0D1F0F; border: 2px solid #C9A84C;
      cursor: pointer; display: flex; align-items: center; justify-content: center;
      box-shadow: 0 4px 20px rgba(0,0,0,0.4);
      transition: transform 0.2s, box-shadow 0.2s;
      animation: cwa-pulse 3s ease-in-out infinite;
    }
    #cwa-bubble:hover { transform: scale(1.1); box-shadow: 0 6px 28px rgba(201,168,76,0.3); }
    #cwa-bubble svg { width: 28px; height: 28px; fill: #C9A84C; }
    @keyframes cwa-pulse {
      0%, 100% { box-shadow: 0 4px 20px rgba(0,0,0,0.4); }
      50% { box-shadow: 0 4px 20px rgba(201,168,76,0.25), 0 0 0 8px rgba(201,168,76,0.08); }
    }
    #cwa-panel {
      position: fixed; bottom: 96px; right: 24px; z-index: 99999;
      width: 380px; max-height: 520px; border-radius: 16px;
      background: #0D1F0F; border: 1px solid rgba(201,168,76,0.2);
      box-shadow: 0 12px 40px rgba(0,0,0,0.5);
      display: none; flex-direction: column; overflow: hidden;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    }
    #cwa-panel.open { display: flex; animation: cwa-slideUp 0.25s ease-out; }
    @keyframes cwa-slideUp { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); } }
    .cwa-header {
      padding: 16px 20px; background: linear-gradient(135deg, #0D1F0F, #142A14);
      border-bottom: 1px solid rgba(201,168,76,0.2); display: flex; justify-content: space-between; align-items: center;
    }
    .cwa-header-left h3 { margin: 0; font-size: 15px; color: #C9A84C; font-weight: 700; letter-spacing: 0.5px; }
    .cwa-header-left p { margin: 2px 0 0; font-size: 10px; color: rgba(245,240,232,0.5); letter-spacing: 0.3px; }
    .cwa-close { background: none; border: none; color: rgba(245,240,232,0.5); font-size: 20px; cursor: pointer; padding: 4px 8px; border-radius: 4px; }
    .cwa-close:hover { color: #F5F0E8; background: rgba(245,240,232,0.07); }
    .cwa-messages {
      flex: 1; overflow-y: auto; padding: 16px; min-height: 280px; max-height: 340px;
      background: #0A1A0A;
    }
    .cwa-msg { margin-bottom: 12px; display: flex; }
    .cwa-msg.user { justify-content: flex-end; }
    .cwa-msg.agent { justify-content: flex-start; }
    .cwa-msg-bubble {
      max-width: 80%; padding: 10px 14px; border-radius: 12px;
      font-size: 13px; line-height: 1.5; word-wrap: break-word;
    }
    .cwa-msg.user .cwa-msg-bubble {
      background: rgba(201,168,76,0.13); color: #F5F0E8; border: 1px solid rgba(201,168,76,0.2);
      border-bottom-right-radius: 4px;
    }
    .cwa-msg.agent .cwa-msg-bubble {
      background: #0D1F0F; color: rgba(245,240,232,0.87); border: 1px solid rgba(201,168,76,0.13);
      border-bottom-left-radius: 4px;
    }
    .cwa-typing { display: flex; gap: 4px; padding: 10px 14px; }
    .cwa-typing span {
      width: 6px; height: 6px; background: rgba(201,168,76,0.4); border-radius: 50%;
      animation: cwa-dot 1.2s infinite;
    }
    .cwa-typing span:nth-child(2) { animation-delay: 0.2s; }
    .cwa-typing span:nth-child(3) { animation-delay: 0.4s; }
    @keyframes cwa-dot { 0%, 60%, 100% { opacity: 0.3; } 30% { opacity: 1; } }
    .cwa-input-area {
      padding: 12px 16px; border-top: 1px solid rgba(201,168,76,0.13);
      background: #0D1F0F; display: flex; gap: 8px;
    }
    .cwa-input {
      flex: 1; padding: 10px 14px; border-radius: 8px; border: 1px solid rgba(201,168,76,0.2);
      background: #0A1A0A; color: #F5F0E8; font-size: 13px; outline: none;
      font-family: inherit;
    }
    .cwa-input::placeholder { color: rgba(245,240,232,0.27); }
    .cwa-input:focus { border-color: rgba(201,168,76,0.4); }
    .cwa-send {
      padding: 10px 16px; border-radius: 8px; border: none;
      background: #C9A84C; color: #0D1F0F; font-weight: 700;
      cursor: pointer; font-size: 13px; transition: background 0.15s;
    }
    .cwa-send:hover { background: #A8852E; }
    .cwa-send:disabled { opacity: 0.4; cursor: not-allowed; }
    @media (max-width: 480px) {
      #cwa-panel { width: calc(100vw - 16px); right: 8px; bottom: 80px; max-height: 70vh; }
      #cwa-bubble { bottom: 16px; right: 16px; width: 52px; height: 52px; }
    }
  `;
  document.head.appendChild(style);
  const bubble = document.createElement('div');
  bubble.id = 'cwa-bubble';
  bubble.innerHTML = '<svg viewBox="0 0 24 24"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"/></svg>';
  bubble.addEventListener('click', togglePanel);
  const panel = document.createElement('div');
  panel.id = 'cwa-panel';
  panel.innerHTML = `
    <div class="cwa-header">
      <div class="cwa-header-left">
        <h3>Ask The Manor</h3>
        <p>Powered by JARVIS</p>
      </div>
      <button class="cwa-close" id="cwa-close-btn">&times;</button>
    </div>
    <div class="cwa-messages" id="cwa-messages"></div>
    <div class="cwa-input-area">
      <input class="cwa-input" id="cwa-input" placeholder="Ask us anything..." autocomplete="off" />
      <button class="cwa-send" id="cwa-send">Send</button>
    </div>
  `;
  document.body.appendChild(bubble);
  document.body.appendChild(panel);
  document.getElementById('cwa-close-btn').addEventListener('click', togglePanel);
  document.getElementById('cwa-send').addEventListener('click', sendMessage);
  document.getElementById('cwa-input').addEventListener('keydown', function(e) {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); }
  });
  function togglePanel() {
    isOpen = !isOpen;
    panel.classList.toggle('open', isOpen);
    bubble.style.display = isOpen ? 'none' : 'flex';
    if (isOpen && messages.length === 0) {
      addMessage('agent', "Welcome to The Outdoor Manor! I'm here to help you find the perfect outdoor living products. What can I help you with?");
    }
    if (isOpen) {
      setTimeout(function() { document.getElementById('cwa-input').focus(); }, 100);
    }
  }
  function addMessage(role, text) {
    messages.push({ role: role, content: text });
    let container = document.getElementById('cwa-messages');
    let div = document.createElement('div');
    div.className = 'cwa-msg ' + (role === 'user' ? 'user' : 'agent');
    div.innerHTML = '<div class="cwa-msg-bubble">' + escapeHtml(text) + '</div>';
    container.appendChild(div);
    container.scrollTop = container.scrollHeight;
  }
  function showTyping() {
    let container = document.getElementById('cwa-messages');
    let div = document.createElement('div');
    div.className = 'cwa-msg agent';
    div.id = 'cwa-typing-indicator';
    div.innerHTML = '<div class="cwa-msg-bubble"><div class="cwa-typing"><span></span><span></span><span></span></div></div>';
    container.appendChild(div);
    container.scrollTop = container.scrollHeight;
  }
  function hideTyping() {
    let el = document.getElementById('cwa-typing-indicator');
    if (el) el.remove();
  }
  function escapeHtml(text) {
    let div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
  function sendMessage() {
    let input = document.getElementById('cwa-input');
    let text = input.value.trim();
    if (!text || isTyping) return;
    addMessage('user', text);
    conversationHistory.push({ role: 'user', content: text });
    input.value = '';
    isTyping = true;
    document.getElementById('cwa-send').disabled = true;
    showTyping();
    fetch(WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        visitor_id: visitorId,
        message: text,
        page_url: window.location.href,
        conversation_history: conversationHistory.slice(-8)
      })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      hideTyping();
      let reply = data.reply || 'I appreciate your patience. How can I help you?';
      addMessage('agent', reply);
      conversationHistory.push({ role: 'assistant', content: reply });
    })
    .catch(function() {
      hideTyping();
      addMessage('agent', 'I apologize for the inconvenience. Please try again or call us at 1-516-619-1396.');
    })
    .finally(function() {
      isTyping = false;
      document.getElementById('cwa-send').disabled = false;
      document.getElementById('cwa-input').focus();
    });
  }
})();